import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const GameDetail = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = window.location.href;
    const token = localStorage.getItem("accessToken");


    let redirectUrl = urlParams;

    // Replace "contests" with "contest" in the URL
    if (redirectUrl.includes("/contests/")) {
      redirectUrl = redirectUrl.replace("/contests/", "/contest/");
    }

    localStorage.setItem("gameurl", JSON.stringify(redirectUrl));
    // Check token and redirect
    if (token) {
      // Redirect to the modified URL
      window.location.href = redirectUrl;
    } else {
      // Navigate to login page if no token
      navigate("/auth/login");
    }
  }, [navigate]);

  return (
    <div>
      <h2>League Detail</h2>
      <p>Loading league details...</p>
    </div>
  );
};

export default GameDetail;
